type RemoteScope = "rateShop" | "orderManagement" | "invoiceManagement";

const REMOTE_BASE: Record<RemoteScope, string> = {
  rateShop: process.env.REACT_APP_RATESHOP_URL as string,
  orderManagement: process.env.REACT_APP_ORDERMGMT_URL as string,
  invoiceManagement: process.env.REACT_APP_INVOICEMGMT_URL as string,
};

/**
 * Checks version.json of a remote app and reloads Portal if version changed.
 *
 * Each child app (rateShop, orderManagement, invoiceManagement) must expose
 * /version.json with structure: { "version": "x.y.z", "buildTime": "..." }
 */
export async function checkRemoteVersion(
  scope: RemoteScope | string,
): Promise<boolean> {
  const base = REMOTE_BASE[scope as RemoteScope];
  if (!base) {
    console.error(`[Portal] No base URL configured for ${scope}`);
    return false;
  }

  const versionUrl = `${base}version.json?ts=${Date.now()}`;
  const key = `remote-version-${scope}`;

  try {
    const res = await fetch(versionUrl, { cache: "no-store" });
    if (!res.ok) throw new Error(`Failed to fetch version.json for ${scope}`);

    const { version, buildTime } = await res.json();
    const current = `${version}_${buildTime}`;
    const stored = sessionStorage.getItem(key);

    if (stored && stored !== current) {
      console.warn(
        `[Portal] ${scope} updated (${stored} → ${current}). Reloading...`,
      );
      sessionStorage.setItem(key, current);
      window.location.reload();
      return true;
    }

    if (!stored) {
      sessionStorage.setItem(key, current);
      console.log(`[Portal] ${scope} initial version → ${current}`);
    }

    return false;
  } catch (err) {
    console.warn(`[Portal] Failed to check ${scope} version:`, err);
    return false;
  }
}
